import {
  ConstructKitFoundations,
  ConstructKitFoundationsOverride,
} from '@rea-group/construct-kit-core';

const white = 'white';
const snowgum50 = '#F5F6F7';
const snowgum100 = '#E3E5E8';
const snowgum200 = '#BABEC2';
const snowgum300 = '#919599';
const snowgum400 = '#6E7275';
const snowgum500 = '#535659';
const snowgum600 = '#3A3D40';
const snowgum700 = '#2C2E30';
const snowgum800 = '#222426';
const snowgum900 = '#1A1D1F';
const snowgum1000 = '#15181A';
const bondi50 = '#D9F2FF';
const bondi200 = '#78BEF0';
const bondi300 = '#3D94DB';
const bondi400 = '#055FB4';
const bondi500 = '#054C99';
const bondi700 = '#032B63';
const rcaBlue = bondi400;

const v4Tokens = {
  textPrimary: { light: snowgum600, dark: snowgum50 },
  textSecondary: { light: snowgum400, dark: snowgum200 },
  textInverted: { light: white, dark: snowgum600 },
  textInvertedStatic: { light: white, dark: snowgum50 },
  textInformation: { light: bondi500, dark: bondi200 },
  textBrand: { light: rcaBlue, dark: snowgum50 },
  backgroundBrandStatic: { light: rcaBlue, dark: rcaBlue },
  backgroundPrimary: { light: white, dark: snowgum700 },
  backgroundPrimaryBase: { light: white, dark: snowgum1000 },
  backgroundPrimaryLow: { light: white, dark: snowgum900 },
  backgroundPrimaryHigh: { light: white, dark: snowgum800 },
  backgroundPrimaryInverted: { light: snowgum600, dark: snowgum100 },
  backgroundPrimaryInvertedStatic: { light: snowgum600, dark: snowgum600 },
  backgroundSecondaryBase: { light: snowgum50, dark: snowgum1000 },
  backgroundSecondaryInvertedStatic: { light: snowgum800, dark: snowgum800 },
  backgroundSecondary: { light: snowgum100, dark: snowgum600 },
  backgroundInformation: { light: bondi50, dark: bondi700 },
  backgroundOverlayStatic: {
    light: 'rgba(34, 36, 38, 0.8)',
    dark: 'rgba(34, 36, 38, 0.8)',
  }, //snowgum800, 80% Opacity
  borderBrandStatic: { light: rcaBlue, dark: rcaBlue },
  borderPrimary: { light: snowgum300, dark: snowgum300 },
  borderSecondary: { light: snowgum100, dark: snowgum500 },
  borderInverted: { light: white, dark: snowgum600 },
  borderInvertedStatic: { light: snowgum300, dark: snowgum300 },
  borderSelected: { light: snowgum600, dark: snowgum50 },
  linkPrimary: { light: bondi500, dark: bondi200 },
  linkSecondary: { light: snowgum400, dark: snowgum200 },
  backgroundHoveredBrandStatic: { light: bondi500, dark: bondi300 },
  backgroundHoveredPrimary: { light: snowgum50, dark: snowgum600 },
  backgroundHoveredPrimaryInverted: { light: snowgum800, dark: snowgum50 },
  backgroundHoveredPrimaryInvertedStatic: {
    light: snowgum800,
    dark: snowgum500,
  },
  backgroundHoveredSecondary: { light: snowgum200, dark: snowgum500 },
  backgroundPressedBrandStatic: { light: bondi500, dark: bondi300 },
  backgroundPressedPrimary: { light: snowgum50, dark: snowgum600 },
  backgroundPressedPrimaryInverted: { light: snowgum800, dark: snowgum50 },
  backgroundPressedPrimaryInvertedStatic: {
    light: snowgum800,
    dark: snowgum500,
  },
  backgroundPressedSecondary: { light: snowgum200, dark: snowgum500 },
  backgroundFocusedPrimary: { light: snowgum50, dark: snowgum500 },
  backgroundSelected: { light: snowgum600, dark: snowgum50 },
  borderHovered: { light: snowgum600, dark: snowgum200 },
  borderHoveredInverted: { light: snowgum50, dark: snowgum500 },
  borderPressed: { light: snowgum50, dark: snowgum200 },
  borderPressedInverted: { light: snowgum600, dark: snowgum500 },
  borderFocused: { light: snowgum600, dark: snowgum50 },
  borderFocusedInvertedStatic: { light: snowgum50, dark: snowgum50 },
  textDisabled: { light: snowgum200, dark: snowgum500 },
  backgroundDisabled: { light: snowgum50, dark: snowgum600 },
  borderDisabled: { light: snowgum100, dark: snowgum500 },
  graphicBlue: { light: bondi400, dark: bondi400 },
  backgroundBlue: { light: bondi50, dark: bondi700 },
  textBlue: { light: bondi500, dark: bondi200 },
};

const commercialOverrideTheme: ConstructKitFoundationsOverride = (
  foundations: ConstructKitFoundations,
) => ({
  ...foundations,
  palette: {
    ...foundations.palette,
    ...v4Tokens,
  },
  layoutBreakpoints: {
    small: '@media (min-width: 361px)',
    medium: '@media (min-width: 501px)',
    large: '@media (min-width: 768px)',
    extraLarge: '@media (min-width: 1024px)',
  },
  maxWidth: '70.375rem',
});

export default commercialOverrideTheme;
